import { FC } from 'react';

import { Box, HStack, IconButton, Text, VStack, XOutline } from '@bonusly/design-system';

interface Initiative {
	id: string;
	title: string;
	summary?: string;
}

interface GoalInitiativeCardProps {
	initiative: Initiative;
	showRemoveButton?: boolean;
	onRemove?: () => void;
}

export const GoalInitiativeCard: FC<GoalInitiativeCardProps> = ({ initiative, showRemoveButton = false, onRemove }) => {
	return (
		<Box position="relative" p={3} borderRadius="md" border="1px solid" borderColor="border.default" bg="bg.surface" w="full">
			{showRemoveButton && onRemove && (
				<IconButton
					aria-label="Remove initiative"
					icon={<XOutline size="xs" />}
					variant="ghost"
					size="xs"
					color="info.icon"
					onClick={onRemove}
					position="absolute"
					top={2}
					right={2}
					zIndex={1}
				/>
			)}
			<HStack spacing={2} align="start">
				<Box w="10px" h="10px" borderRadius="full" bg="blue.100" flexShrink={0} mt="0.3rem" />
				<VStack align="start" spacing={1} flex={1} pr={showRemoveButton ? 8 : 0}>
					<Text fontSize={50} fontWeight="semibold" color="text.default">
						{initiative.title}
					</Text>
					{initiative.summary && (
						<Text fontSize={50} color="text.softer" lineHeight="relaxed">
							{initiative.summary}
						</Text>
					)}
				</VStack>
			</HStack>
		</Box>
	);
};
